import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./locales/es.json";

// Único idioma disponible por ahora. Cuando sumemos en/fr, alcanza con:
//   import en from "./locales/en.json"; import fr from "./locales/fr.json";
//   y agregarlos al objeto `resources` de abajo.
const idiomaGuardado = localStorage.getItem("idioma") || "es";

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
  },
  lng: idiomaGuardado,
  fallbackLng: "es",
  interpolation: { escapeValue: false },
});

export default i18n;
